"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PLUGINS = void 0;
var _useChartCartesianAxis = require("./featurePlugins/useChartCartesianAxis");
var _useChartHighlight = require("./featurePlugins/useChartHighlight");
var _useChartInteraction = require("./featurePlugins/useChartInteraction");
var _useChartVoronoi = require("./featurePlugins/useChartVoronoi");
var _useChartZAxis = require("./featurePlugins/useChartZAxis");
// This file should be removed after creating all plugins in favor of a file per chart type.

const DEFAULT_PLUGINS = exports.DEFAULT_PLUGINS = [_useChartZAxis.useChartZAxis, _useChartCartesianAxis.useChartCartesianAxis, _useChartInteraction.useChartInteraction, _useChartHighlight.useChartHighlight, _useChartVoronoi.useChartVoronoi];